// imageFile.ts — 직인·파트 이미지 업로드 전 클라이언트 검증(타입/크기) 순수 헬퍼.
// 바이트 전송은 multipart 업로드(오브젝트 스토리지) — data URL 변환은 폐기.

export const MAX_SEAL_BYTES = 1024 * 1024; // 1MB — 서버 MAX_SEAL_BYTES 와 짝.

// 이미지 파일 검증 — 문제 없으면 null, 있으면 토스트용 한국어 메시지. what 은 메시지 주어.
export function imageFileError(
  file: { type: string; size: number },
  what = "이미지"
): string | null {
  if (!file.type.startsWith("image/")) return "이미지 파일만 업로드할 수 있습니다";
  if (file.size > MAX_SEAL_BYTES) return `${what}는 1MB 이하여야 합니다`;
  return null;
}

// 직인 파일 검증 — 기존 호출부/메시지 유지용 래퍼.
export const sealFileError = (file: { type: string; size: number }): string | null =>
  imageFileError(file, "직인 이미지");
